(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jib-campaign-announcement')) {
  customElements.define('jib-campaign-announcement', class extends HTMLElement {
    connectedCallback() {
      const restore = () => {
        const campaign = this.querySelector('[data-campaign]');
        const fallback = this.querySelector('[data-fallback]');
        if (campaign) campaign.hidden = true;
        if (fallback) fallback.hidden = false;
      };
      const checkExpiry = () => {
        const remaining = Number(this.dataset.end) - Date.now();
        if (remaining <= 0) restore();
        else this.expiryTimer = setTimeout(checkExpiry, Math.min(remaining, 2147483647));
      };
      checkExpiry();
    }
    disconnectedCallback() { clearTimeout(this.expiryTimer); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
